import { Outlet } from "react-router-dom";

import Header from "components/Header/Header";
import usePrefetch from "hooks/insights/usePrefetch";
import useFirebaseActions from "hooks/useFirebaseActions";
import { useUser } from "stores/useUser";
import { useEffect } from "react";
import { doc, setDoc } from "firebase/firestore";
import { FirestoreDB } from "utils/firebase";
import GoogleCalendarWarning from "components/IntegrationsModal/GoogleCalendarWarning";
import { isGoogleCalendarConnected } from "utils/common";
import UpcomingMeetingReminderHost from "components/Workspace/UpcomingMeetingReminder";

const Layout = ({ source }) => {
  const { user } = useUser();
  // for now using this prefetch for insights
  usePrefetch({ source });

  // to have the actions in global state and be able to recieve notifications at any page in app
  useFirebaseActions();

  // setting access time to db
  useEffect(() => {
    const handleLastTimeAccess = async () => {
      try {
        await setDoc(
          doc(FirestoreDB, "users", user.uid),
          { lastTimeAccessed: new Date() },
          { merge: true },
        );
      } catch (error) {
        // Silently handle permission errors (e.g., for impersonated users)
        if (error.code !== "permission-denied") {
          console.error("Error updating last access time:", error);
        }
      }
    };
    handleLastTimeAccess();
  }, [user]);
  if (source === "extension") {
    return (
      <>
        <Outlet />
      </>
    );
  }
  const isGoogleCalendarWarningNeeded = isGoogleCalendarConnected(user);
  return (
    <>
      <UpcomingMeetingReminderHost
        user={user}
        enabled={source !== "extension"}
      />
      <Header />
      <div style={{ marginTop: "4.5rem" }}>
        {!isGoogleCalendarWarningNeeded && <GoogleCalendarWarning />}
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
